import React, { lazy } from 'react';
import { IGame } from '@/interface/game';
import { gameCategory } from '../../constants/game';
import MarkerlessContent from './ARCategory/MarkerLess/MarkerlessContent';
import MarkerBasedContent from './ARCategory/MarkerBased/MarkerBasedContent';
import ARCategoryGameContent from './ARCategory/Games/ARCategoryGameContent';
import AroundContent from './ARCategory/Around/AroundContent';
import ImageTrackingContent from './ARCategory/ImageTracking/ImageTrackingContent';
const FaceTryonContent = lazy(
  () => import('./ARCategory/FaceTryon/FaceTryonContent')
);

type ArGameProps = {
  game: IGame;
};
const ARGameBody = ({ game }: ArGameProps) => {
  const renderGameContent = () => {
    switch (game?.category) {
      case gameCategory.MARKERLESS:
        return <MarkerlessContent config={game?.config} />;
      case gameCategory.MARKERBASED:
        return <MarkerBasedContent config={game?.config} />;
      case gameCategory.FACE_TRYON:
        return <FaceTryonContent config={game?.config} />;
      case gameCategory.GAME:
        return (
          <ARCategoryGameContent
            config={game?.config}
            type={game?.type || ''}
          />
        );
      case gameCategory.AROUND:
        return <AroundContent config={game?.config} />;
      case gameCategory.IMAGE_TRACKING:
        return <ImageTrackingContent config={game?.config} />;
      default:
        return null;
    }
  };
  return <>{renderGameContent()}</>;
};

export default ARGameBody;
